const cookiesPreferencesLink = document.getElementById('copyright-link-cookies');

cookiesPreferencesLink &&
    cookiesPreferencesLink.addEventListener('click', (e) => {
        e.preventDefault();

        window.Osano && window.Osano.cm.showDrawer('osano-cm-dom-info-dialog-open');
    });
